/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {global} from './lang';

export var Math = global.Math;
export var NaN: any /** TODO #???? */ = typeof NaN;

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
